import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { breadcrumbsActions } from "@store/breadcrumbs";
import ApplicationPageTemplate from "../../dashboard/components/ApplicationPageTemplate/ApplicationPageTemplate";
import { getIncidents } from "@store/smart-alerts.js";
import { DataGrid } from "@mui/x-data-grid";
import { Avatar } from "@mui/material";
import { Box } from "@mui/system";
import H6 from "@components/H6";
import Subtitle1 from "@components/Subtitle1";
import DateTimeText from "../../../components/DateTimeText";

const IncidentList = () => {
	const dispatch = useDispatch();
	const incidents = useSelector((state) => state.smartAlerts.incidents);
	const [isFetchingData, setIsFetchingData] = useState(true);

	useEffect(() => {
		dispatch(breadcrumbsActions.showMenu(true));
		dispatch(
			breadcrumbsActions.setBreadcrumbs([
				{ label: "Home", url: "/" },
				{ label: "Smart Alerts", url: "/smart-alerts" },
				{ label: "Incidents", url: "/smart-alerts/incidents" },
			])
		);
	});

	useEffect(() => {
		setIsFetchingData(true);
		dispatch(getIncidents()).then(() => {
			setIsFetchingData(false);
		});
	}, [dispatch]);

	return (
		<ApplicationPageTemplate title="Incidents List" description="List of the incidents detected by the configured alerts, deleted alerts has no incidents in the list" pageReady={!isFetchingData}>
			<DataGrid
				autoHeight={true}
				style={{ background: "white" }}
				rows={incidents}
				density="comfortable"
				rowHeight={100}
				disableColumnFilter={true}
				disableColumnMenu={true}
				disableColumnSelector={true}
				disableDensitySelector={true}
				disableSelectionOnClick={true}
				columns={[
					{
						field: "id",
						headerName: "ID",
						width: 80,
						sortable: false,
						headerAlign: "center",
						align: "center",
						renderCell: ({ row }) => <Avatar>{row.id}</Avatar>,
					},
					{
						field: "title",
						headerName: "Title",
						flex: 1,
						sortable: false,
						renderCell: ({ row }) => (
							<>
								<Box sx={{ width: "100%", maxWidth: 500 }}>
									<H6>{row.title}</H6>
									<Subtitle1>{row.description}</Subtitle1>
								</Box>
							</>
						),
					},
					{
						field: "createdAt",
						headerName: "Detected At",
						renderCell: ({ row }) => <DateTimeText dateTime={row.createdAt} />,
						width: 140,
						sortable: false,
						headerAlign: "center",
						align: "center",
					},
					{
						field: "context",
						headerName: "Context",
						renderCell: ({ row }) => <Box sx={{ width: "100%", wordBreak: "break-word", whiteSpace: "break-spaces" }}>{row.context ? JSON.stringify(row.context) : "NA"}</Box>,
						width: 340,
						sortable: false,
						headerAlign: "left",
						align: "left",
					},
				]}
				pageSize={5}
				rowsPerPageOptions={[5]}
			></DataGrid>
		</ApplicationPageTemplate>
	);
};

export default IncidentList;
